export const ANALYTICS_TRACK = "analyticsTracking";
export const STORY_METADATA = "storyMetadata";
export const CHAPTER_END = "chapterEnd";
export const HOTSPOT_CLICK = "hotspotClick";
export const NAVIGATION = "navigation";
export const MEDIA_PLAYBACK = "mediaPlayback";
export const SHOW_TILE_CONTROLS = "showTileControls";
